const pdfWorkerSrc = new URL(
  'pdfjs-dist/build/pdf.worker.min.mjs',
  import.meta.url
).toString()

export const setupPdfWorker = pdfjs => {
  pdfjs.GlobalWorkerOptions.workerSrc = pdfWorkerSrc || '/pdf.worker.min.mjs'
}
